/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useEffect } from "react";
import {
	ButtonLayout,
	ButtonPrimary,
	Grid,
	IconWarningLight,
	Text3,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";

import { observer } from "mobx-react-lite";
import { useAnalytics, useNavigateCustom } from "../../../hooks";
import { strings } from "../../../localization";
import { ScreenResponsive } from "../../../components/organisms";
import { FeedbackContainer } from "../../../components";

const { button, description, title } = strings.pages.errorOpenSettlementWithUpperLimit;

const ErrorOpenSettlementWithUpperLimit: React.FC = observer(() => {
	const navigation = useNavigateCustom();
	const { isDesktopOrBigger } = useScreenSize();
	const { addAnalyticEvent, updatePageView } = useAnalytics();

	useEffect(() => {
		updatePageView({ name: "Vivo Pay FGTS Quitação de contrato atual maior que 24 meses", pagePath: "/fgts/error_open_settlement_with_upper_limit" });
	}, []);

	// Efetua o refetch da última requisição
	const onHandleLogout = () => {
		navigation("/", { replace: true });
		addAnalyticEvent({ action: "click.button", step: "fgts:error", description: button }, { applySanitize: true});
	};

	const handlePopState = (): void => {
		navigation("/", { replace: true });
	};

	useEffect(() => {

		// Adiciona um listener ao evento popstate
		window.addEventListener("popstate", handlePopState);

		// Limpa o listener ao desmontar o componente
		return () => {
			window.removeEventListener("popstate", handlePopState);
		};
	}, [navigation]);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<FeedbackContainer
					icon={<IconWarningLight size={64} color={skinVars.colors.controlError} />}
					title={title}
					description={description}
				>
					<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
						<ButtonPrimary onPress={onHandleLogout} style={{ width: isDesktopOrBigger ? "auto" : "100%" }}>
							<Text3 medium color={skinVars.colors.textButtonPrimary}>
								{button}
							</Text3>
						</ButtonPrimary>
					</ButtonLayout>
				</FeedbackContainer>
			</Grid>
		</ScreenResponsive>
	);
});

export default ErrorOpenSettlementWithUpperLimit;
